import { render, staticRenderFns } from "./ShiftDetails.vue?vue&type=template&id=4af0ec26&"
import script from "./ShiftDetails.vue?vue&type=script&lang=ts&"
export * from "./ShiftDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports